<template>
  <div class="order-container">
    <el-card>
      <div slot="header">
        <span>课程信息</span>
      </div>

      <!-- 搜索区域 -->
      <div class="search-box" style="margin-bottom: 20px;">
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline">
          <el-form-item label="课程名">
            <el-input 
              v-model="searchForm.courseName" 
              placeholder="请输入课程名" 
              clearable
              style="width: 200px;"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
            <el-button @click="handleReset" icon="el-icon-refresh-left">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 用户表格 -->
      <el-table :data="tableData" v-loading="loading" @sort-change="sortChange" style="width: 100%" border>
        <el-table-column prop="icourseid" label="ID" width="100"></el-table-column>
        <el-table-column prop="ccoursename" label="课程名"></el-table-column>
        <el-table-column prop="type" label="课程类型">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.type === 0 ? 'primary' : 'success'"
              disable-transitions>{{scope.row.type === 0 ? '专业课' : '公共课'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="inventory" label="激活码库存" sortable></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="text" @click="handleAdd(scope.row)">添加激活码</el-button>
            <el-button size="small" type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页（可选） -->
      <div class="pagination" style="margin-top: 20px; text-align: right;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="prev, pager, next, total, sizes"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    
    <!-- 编辑用户信息弹窗 -->
    <el-dialog title="编辑课程信息" :visible.sync="editDialogVisible">
      <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="120px">
        <el-form-item label="ID" prop="icourseid">
          <el-input v-model="editForm.icourseid" disabled></el-input>
        </el-form-item>
        <el-form-item label="课程名" prop="ccoursename">
          <el-input v-model="editForm.ccoursename"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
            <el-radio-group v-model="editForm.type">
            <el-radio :label="0">专业课</el-radio>
            <el-radio :label="1">公共课</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>

    <!-- 添加激活码弹窗 -->
    <el-dialog :title="addTitle" :visible.sync="addDialogVisible">
      <el-form :model="addForm" :rules="addRules" ref="addFormRef">
        <el-form-item label="激活码" prop="code">
          <el-input type="textarea" v-model="addForm.code" :autosize="{ minRows: 10}" placeholder="请输入激活码" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="clearAdd">取消</el-button>
        <el-button type="primary" @click="submitAdd">添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Orders',
  data() {
    return {
      loading: false,
      tableData: [],
      order: "",
      // 分页相关（暂不启用）
      page: 1,
      pageSize: 10,
      total: 0,

      // 编辑弹窗
      editDialogVisible: false,
      addDialogVisible: false,
      addTitle: "",
      editForm: {
        icourseid: '',
        ccoursename: '',
        type: '',
      },

      addForm: {
        code: '',
      },
      parsedData: [],

      editRules: {
        ccoursename: [{ required: true, message: '请输入课程名', trigger: 'blur'}],
      },

      addRules: {
        code: [{ required: true, message: '请输入激活码数据', trigger: 'blur'}],
      },
      
      currentEditCourse: null, // 用于临时保存当前编辑的用户
      currentAddCourse: null,

      // 搜索表单
      searchForm: {
        courseName: ''
      }
    }
  },
  filters: {
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
    }
  },
  created() {
    this.fetchCourseList();
  },
  methods: {

    async fetchCourseList() {
      this.loading = true
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          order: this.order || undefined,
          courseName: this.searchForm.courseName || undefined,
        };
        const {data: res}= await this.$http.get('get_course_list', {params});
        this.tableData = res.data
        this.total = res.total
      } catch (error) {
        this.$message.error('获取订单列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    // 搜索
    async handleSearch() {
      const valid = await this.$refs.searchForm.validate().catch(() => false);
      if (!valid) {
        this.$message.warning('请输入课程名');
        return;
      }
      this.page = 1; // 搜索时重置到第一页
      this.fetchCourseList();
    },

    // 重置搜索条件
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {
        courseName: ''
      };
      this.page = 1;
      this.fetchCourseList();
    },

    // 编辑课程
    handleEdit(row) {
      this.currentEditCourse = { ...row }
      this.editForm = { ...row }
      this.editDialogVisible = true
    },

    // 添加激活码
    handleAdd(row) {
      this.currentAddCourse = { ...row }
      this.addTitle = "添加激活码 - " + row.ccoursename
      this.addForm = {code: '', courseId: row.icourseid, courseName: row.ccoursename}
      this.addDialogVisible = true
    },

    async handleDelete(row) {
      try {
          const params = {
            courseid: row.icourseid
          }
          const {data: res}= await this.$http.get('delete_course', {params});
          if (res.code == 200){
            this.$message.success('课程删除成功')
            this.fetchCourseList() // 刷新列表
          } else{
            this.$message.error('删除失败')
          }
          this.editDialogVisible = false
        } catch (error) {
          this.$message.error('删除失败')
        }
    },

    submitEdit() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        try {
          const {data: res}= await this.$http.post('update_course_info', this.editForm);
          if (res.code == 200){
            this.$message.success('课程信息更新成功')
            this.fetchCourseList() // 刷新列表
          } else{
            this.$message.error('更新失败')
          }
          this.editDialogVisible = false
        } catch (error) {
          this.$message.error('更新失败')
        }
      })
    },
    clearAdd() {
      this.addDialogVisible = false;
      this.addForm = {code: '', courseId: ''}
    },

    submitAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        try {
          const {data: res}= await this.$http.post('create_code', this.addForm);
          if (res.code == 200){
            this.$message.success('激活码添加成功')
            this.fetchCourseList() // 刷新列表
          } else{
            this.$message.error('添加失败')
          }
          this.addDialogVisible = false
        } catch (error) {
          this.$message.error('添加失败')
        }
      })
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.fetchCourseList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchCourseList();
    },
    sortChange(val) {
      this.order = val.order;
      this.fetchCourseList()
    }
  }
}
</script>

<style lang="less">
.order-container {
  padding: 20px;
}

.password_show {
  .el-input__inner {
    border: none;
    background-color: rgba(255, 255, 255, 0);
  }
}
</style>